import { useWeb3React } from "@web3-react/core";
import { getContract } from "config/contracts";
import { ethers } from "ethers";
import { useChainId } from "lib/chains";
import { callContract } from "lib/contracts";
import { formatAmount } from "lib/numbers";
import FeeDistribution from "abis/MultiFeeDistribution.json";
import ChefIncentives from "abis/ChefIncentives.json";
const useLockMMYLP = (setPendingTxns) => {
  const { chainId } = useChainId();
  const { library, account } = useWeb3React();
  const FeeDistributionAddress = getContract(chainId, "MultiFeeDistribution");
  const ChefIncetivesAddress = getContract(chainId, "ChefIncetives");
  const setLock = async (amount, type) => {
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    await callContract(chainId, FeeDistributionContract, "stake", [amount, account, type], {
      sentMsg: `Lock submitted!`,
      failMsg: `Lock failed.`,
      successMsg: `Locked ${formatAmount(amount, 18, 2, true)} successfully!`,
      setPendingTxns,
    })
      .then(async (res) => {
        const receipt = await res.wait();
        return receipt;
      })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }
  const setAutoReLock = async (status) => {
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    await callContract(chainId, FeeDistributionContract, "setRelock", [status], {
      sentMsg: `Relock submitted!`,
      failMsg: `Relock failed.`,
      successMsg: `Relocked successfully!`,
      setPendingTxns,
    })
      .then(async (res) => {
        const receipt = await res.wait();
        return receipt;
      })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }
  const reLock = async () => {
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    await callContract(chainId, FeeDistributionContract, "relock", [], {
      sentMsg: `Relock submitted!`,
      failMsg: `Relock failed.`,
      successMsg: `Relocked successfully!`,
      setPendingTxns,
    })
      .then(async (res) => { })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }
  const setWithdraw = (amount) => {
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    callContract(chainId, FeeDistributionContract, "withdraw", [amount], {
      sentMsg: `Withdraw submitted!`,
      failMsg: `Withdraw failed.`,
      successMsg: `Withdrew successfully!`,
      setPendingTxns,
    })
      .then(async (res) => { })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }
  const getAllRewards = async () => {
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    await callContract(chainId, FeeDistributionContract, "getAllRewards", [], {
      sentMsg: `Withdraw submitted!`,
      failMsg: `Withdraw failed.`,
      successMsg: `Withdrew successfully!`,
      setPendingTxns,
    })
      .then(async (res) => {
        const receipt = await res.wait();
        return receipt;
      })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }
  const vestToken = async (tokens) => {
    const ChefIncetivesContract = new ethers.Contract(ChefIncetivesAddress, ChefIncentives.abi, library?.getSigner());
    await callContract(chainId, ChefIncetivesContract, "claim", [account, tokens], {
      sentMsg: `Vest submitted!`,
      failMsg: `Vest failed.`,
      successMsg: `Vested successfully!`,
      setPendingTxns,
    })
      .then(async (res) => {
        const receipt = await res.wait();
        return receipt;
      })
      .finally(() => {
        // setIsSubmitting(false);

      });
  }
  const setExit = (claimRewards = true) => {
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    callContract(chainId, FeeDistributionContract, "exit", [claimRewards], {
      sentMsg: `Exit submitted!`,
      failMsg: `Exit failed.`,
      successMsg: `Exit successfully!`,
      setPendingTxns,
    })
      .then(async (res) => { })
      .finally(() => {
        // setIsSubmitting(false);
      });
  }
  const setChangeDefaultLockType = async (lockType) => {
    const FeeDistributionContract = new ethers.Contract(FeeDistributionAddress, FeeDistribution.abi, library?.getSigner());
    await callContract(chainId, FeeDistributionContract, "setDefaultRelockTypeIndex", [lockType], {
      sentMsg: `Exit submitted!`,
      failMsg: `Exit failed.`,
      successMsg: `Exit successfully!`,
      setPendingTxns,
    })
      .then(async (res) => {
        const receipt = await res.wait();
        return receipt;
      }
      )
  }
  return { setLock, setAutoReLock, setWithdraw, reLock, getAllRewards, vestToken, setExit, setChangeDefaultLockType }
}
export default useLockMMYLP;
